<script>
import parrafos from "@/assets/parrafos.json"
export default {

    setup() {
        return {
            parrafos
        };
    }
}
</script>

<template>
    <!-- <div v-if="parrafos != undefined"> -->
    <div>
        <p class="glow">{{ parrafos["title"] }}</p>
        
    </div>
</template>

<style scoped>
p {
    color: aliceblue;
    font-size: 2rem;


}


.glow {
  font-size: 3rem;
  color: #fff;
  text-align: center;
  animation: glow 1s ease-in-out infinite alternate;
}

</style>